import { Button, GridRow } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridRow 
			growAllChildren
		>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="secondary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
		</GridRow>
	);
};